"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Settings = function Settings(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    fill: "#000000",
    width: "24",
    height: "24",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,10h-2.9c-0.2-0.8-0.5-1.7-0.8-2.3l2-2c0.2-0.2,0.2-0.5,0-0.7l-2.8-2.8c-0.2-0.2-0.5-0.2-0.7,0l-2,2 c-0.7-0.3-1.5-0.6-2.3-0.8V0.5C14,0.2,13.8,0,13.5,0h-3C10.2,0,10,0.2,10,0.5v2.9C9.2,3.6,8.3,3.8,7.7,4.1l-2-2 c-0.2-0.2-0.5-0.2-0.7,0L2.1,4.9c-0.2,0.2-0.2,0.5,0,0.7l2,2C3.8,8.3,3.6,9.2,3.4,10H0.5C0.2,10,0,10.2,0,10.5v3 C0,13.8,0.2,14,0.5,14h2.9c0.2,0.8,0.5,1.7,0.8,2.3l-2,2c-0.2,0.2-0.2,0.5,0,0.7l2.8,2.8c0.2,0.2,0.5,0.2,0.7,0l2-2 c0.7,0.3,1.5,0.6,2.3,0.8v2.9c0,0.3,0.2,0.5,0.5,0.5h3c0.3,0,0.5-0.2,0.5-0.5v-2.9c0.8-0.2,1.7-0.5,2.3-0.8l2,2 c0.2,0.2,0.5,0.2,0.7,0l2.8-2.8c0.2-0.2,0.2-0.5,0-0.7l-2-2c0.3-0.7,0.6-1.5,0.8-2.3h2.9c0.3,0,0.5-0.2,0.5-0.5v-3 C24,10.2,23.8,10,23.5,10z M12,16c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S14.2,16,12,16z"
  }));
};

var _default = Settings;
exports["default"] = _default;